import { Helmet } from "react-helmet-async";

import ContactDetails from "components/pages/ContactUs/ContactDetails";
import ContactForm from "components/common/ContactForm";
import PageBanner from "components/common/PageBanner";
import Stack from "@mui/material/Stack";

function ContactUs() {
  return (
    <Stack spacing={10}>
      <Helmet>
        <title>Liên hệ với The English Tree</title>
        <meta
          name="description"
          content="Liên lạc theo số 0966 766 839 hoặc theenglishtree.edu@gmail.com."
        />
        <link
          rel="canonical"
          href="https://englishtree.edu.vn/dang-ki-hoc-thu"
        />
      </Helmet>

      <PageBanner
        backgroundImage="/images/blue-banner.png"
        heading="Đăng kí học thử"
        pageName="Đăng kí học thử"
      />

      <ContactForm />

      <Stack alignItems="center">
        <div style={{ width: "100%", maxWidth: 800 }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.463813106936!2d106.75878859999999!3d10.928294200000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3174d9bab2a4cfc9%3A0x11d9a76db2e4aa7f!2zNDAwIEzDqiBI4buTbmcgUGhvbmcsIFTDom4gQsOsbmgsIETEqSBBbiwgQsOsbmggRMawxqFuZywgVmlldG5hbQ!5e0!3m2!1sen!2sca!4v1683265058120!5m2!1sen!2sca"
            title="address-1-map"
            width="100%"
            height={400}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            style={{ border: 0, borderRadius: 10 }}
          />
        </div>
        <div style={{ width: "100%", maxWidth: 800 }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.7581347284613!2d106.75222934180934!3d10.905977155839778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3174d93f7cac6e1b%3A0xba00568d1c9461ee!2sBcons%20Tower%20VI!5e0!3m2!1sen!2sca!4v1771105723790!5m2!1sen!2sca"
            title="address-2-map"
            width="100%"
            height={400}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            style={{ border: 0, borderRadius: 10 }}
          />
        </div>

        <div style={{ width: "100%", maxWidth: 800 }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.051291946593!2d106.75440717554034!3d10.905772056793563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3174d84560e2f8f5%3A0x39ba43304209c8b7!2zTmjDoCBTw6FjaCBIb8OgbmcgUGjDumM!5e0!3m2!1sen!2sca!4v1771105516975!5m2!1sen!2sca"
            title="address-3-map"
            width="100%"
            height={400}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            style={{ border: 0, borderRadius: 10 }}
          />
        </div>
      </Stack>

      <ContactDetails />
    </Stack>
  );
}

export default ContactUs;
